import type { PreOrderSmsMessage } from "@stockline/shared/types/orders/pre-order-sms-message"
import type { OfflineResourceConfig } from "../../../types"
import { PRE_ORDER_SMS_MESSAGE_TABLE } from "./db"

export const preOrderSmsMessageConfig: OfflineResourceConfig<PreOrderSmsMessage> =
  {
    name: "pre-order-sms-messages",
    // Server visibility is GROUP-scoped: wiped + cold re-pulled on a
    // scope change (STK-1238).
    groupScoped: true,
    // HOT via the parent pre-order (server floor by parent JOIN). STK-1322.
    tier: "hot",
    windowedBy: "pre-orders",
    window: { days: 30 },
    endpoints: {
      full: "/api/v2/pre-order-sms-messages",
      delta: "/api/v2/pre-order-sms-messages/changes",
      push: "/api/v2/pre-order-sms-messages/changes",
    },
    tableName: PRE_ORDER_SMS_MESSAGE_TABLE,
    primaryKey: "id",
    indexes: {
      companyId: "companyId",
      preOrderId: "preOrderId",
      messageId: "messageId",
      smsChatId: "smsChatId",
      deletedAt: "deletedAt",
    },
    applyChange: (local, patch) => ({ ...local, ...patch }),
  }
